module.exports = __webpack_public_path__ + "static/icon-74141c3d7172aba4ba026102a596a2b1.svg";